import * as angular from 'angular';
import {IController} from 'angular';
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {AccountModel} from "../../angular/models/account.model";
import {AgentsService} from "../../../agents/services/agents-service.service";

export class AccountAgentsViewCtrl implements IController {

  account: AccountModel;

  public queryString: string;
  public status: any;
  public columns: any;

  public doReload: boolean;

  /* @ngInject */
  constructor(private agentDialogService: AgentDialogService, private $state,
              private agentConstants, private $log, private agentsService: AgentsService) {
    this.doReload = false;
  }

  $onInit() {
    this.columns = this.agentConstants.agentsTableColumnsMapLean;
  }

  changeStatus(status) {
    this.status = status;
  }

  submitQuery(queryString) {
    this.queryString = queryString;
  }

  onInviteAgent(event) {
    let loading = false;
    this.agentDialogService.addAgent(event, [])
      .then((agent) => {
        this.updateAgentCarrier(agent.id);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  addAgent(event) {
    this.agentDialogService.createAgent(event, this.account)
      .then((createdAgent) => {
        this.$state.go('agent.agent-profile', {id: createdAgent.id, createdAgent: createdAgent});
      })
  }


  private updateAgentCarrier(agentId: string) {
    this.agentsService.updateCarrier(agentId, this.account.id)
      .then((res) => {
        // Reload list
        this.doReload = true;
      })
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountAgentsView', {
    bindings: {
      account: '<'
    },
    template: require('./account-agents-view.html').default,
    controller: AccountAgentsViewCtrl
  })
